// extracted by mini-css-extract-plugin
export default {"wrapper":"AdoptionLogin_wrapper__H-Prd","select":"AdoptionLogin_select__NL6ao","button":"AdoptionLogin_button__qhmYe","input":"AdoptionLogin_input__2Qk4L"};